export enum BrandsEnum {
  moulinex = 'MOULINEX',
  rowenta = 'ROWENTA',
  tefal = 'TEFAL',
  krups = 'KRUPS',
  calor = 'CALOR',
  seb = 'SEB',
  hob = 'HOB',
  default = ''
}
